import React from "react";
import { Overlay, Popover, Col, Row, Form } from "react-bootstrap";
import filter from "../../assets/images/filt.svg";
import close from "../../assets/images/close.svg";
import { qutationDateFormatV2 } from "../../actions";
import { DatePicker } from "antd";
import moment from "moment";
import "antd/dist/antd.css";

class QutationFilter extends React.Component {
    constructor() {
        super();
        this.state = {
            status: {
                Draft: false,
                Generated: false,
                Cancelled: false,
                Confirmed: false,
                Revised: false,
                BOQ_GENERATED: false
            },
            show: false,
            cur: "",
            eff: "",
            target: null,
        };
        this.myRef = React.createRef();
        this.statusHandler = this.statusHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
        this.currentHandler = this.currentHandler.bind(this);
        this.effHandler = this.effHandler.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose = () => {
        this.setState({
            show: false,
            target: null
        });
    };


    effHandler = (val) => {
        let item = val === null ? "" : qutationDateFormatV2(val._d)
        this.setState({
            cur: item
        })
    }
    currentHandler = (val) => {
        let item = val === null ? "" : qutationDateFormatV2(val._d)
        this.setState({
            eff: item
        })
    }

    statusHandler = (event) => {
        const { name, checked } = event.target;

        this.setState((prevState) => {
            const status = prevState.status;
            status[name] = checked;
            return status;
        });
    };

    submitHandler = (e) => {
        e.preventDefault();
        const { status, eff, cur } = this.state;
        const { onSubmit } = this.props;

        const addedStatus = Object.keys(status)
            .filter((key) => status[key]).map((item) => item)
            .join(",");

        let data = {
            "status": addedStatus,
            "fromDate": eff,
            "toDate": cur
        }
        onSubmit(data);
        this.setState({
            show: false,
            target: null
        })
    }


    resetHandler = () => {
        const { reset } = this.props;
        reset();
        this.setState({
            status: {
                Draft: false,
                Generated: false,
                Cancelled: false,
                Confirmed: false,
                Revised: false,
                BOQ_GENERATED: false
            },
            cur: "",
            eff: "",
            show: false,
            target: null
        })
    }

    handleClick = (event) => {
        this.setState({
            show: !this.state.show,
            target: event.target
        })
    };


    render() {
        const { show, target, ref, status, eff, cur } = this.state;

        const disabledDate = (current) => current && current > moment().endOf("day");
        const checkDisabledDate = (current) => (current && current > moment().endOf("day")) || moment(eff).startOf("day") > current;

        return (
            <div ref={this.myRef} className="filter-background">
                <button onClick={this.handleClick} className="product-filter-button">
                    <img src={filter} alt="..." width="18px" style={{ paddingRight: "5px" }} /> Filter
                </button>
                <Overlay
                    show={show}
                    target={target}
                    placement="bottom"
                    container={ref}
                    containerPadding={20}
                >
                    <Popover id="popover-contained">
                        <Popover.Header>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <p style={{ margin: 0 }}>Status</p>
                                <img
                                    src={close}
                                    alt="Close"
                                    width="16px"
                                    style={{ cursor: "pointer", marginLeft: 'auto' }}
                                    onClick={this.handleClose}
                                />
                            </div>
                        </Popover.Header>
                        <Popover.Body>
                            <div className="filter-page">
                                <Form onSubmit={this.submitHandler}>
                                    <div className="customer-check">
                                        <Form.Check
                                            checked={status.Draft}
                                            onChange={this.statusHandler}
                                            inline label="Draft"
                                            name="Draft"
                                            defaultValue="Draft"
                                            type="checkbox"
                                            className="form-check-label new-tic"
                                        />
                                    </div>
                                    <div className="customer-check">
                                        <Form.Check
                                            checked={status.Generated}
                                            onChange={this.statusHandler}
                                            inline label="Generated"
                                            name="Generated"
                                            defaultValue="Generated"
                                            type="checkbox"
                                            className="form-check-label"
                                        />
                                    </div>

                                    <div className="customer-check">
                                        <Form.Check
                                            checked={status.Cancelled}
                                            onChange={this.statusHandler}
                                            inline label="Cancelled"
                                            name="Cancelled"
                                            defaultValue=" Cancelled"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div className="customer-check">
                                        <Form.Check
                                            checked={status.Confirmed}
                                            onChange={this.statusHandler}
                                            inline label="Confirmed"
                                            name="Confirmed"
                                            defaultValue=" Confirmed"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div className="customer-check">
                                        <Form.Check
                                            checked={status.Revised}
                                            onChange={this.statusHandler}
                                            inline label="Revised"
                                            name="Revised"
                                            defaultValue="Revised"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div className="customer-check">
                                        <Form.Check
                                            checked={status.BOQ_GENERATED}
                                            onChange={this.statusHandler}
                                            inline label="Boq Generated"
                                            name="BOQ_GENERATED"
                                            defaultValue="BOQ_GENERATED"
                                            type="checkbox"
                                        // className="form-check-label new-tic"
                                        />
                                    </div>
                                    <p className="new-ss">Custom Date</p>
                                    <Form.Group controlId="formBasicDate">
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            placeholder={eff !== "" ? eff : "From Date"}
                                            className="form-control"
                                            onChange={this.currentHandler}
                                            disabledDate={disabledDate}
                                        />
                                    </Form.Group><br></br>
                                    <Form.Group controlId="formBasicDate">
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            placeholder={cur !== "" ? cur : "To Date"}
                                            className="form-control"
                                            disabledDate={checkDisabledDate}
                                            onChange={this.effHandler}
                                        />
                                    </Form.Group>

                                    <div>
                                        <Row>
                                            <Col md={6}>
                                                <button className="modal-price reset" type="button" onClick={this.resetHandler}>
                                                    Reset</button>
                                            </Col>
                                            <Col md={6}>
                                                <button type="submit" className="modal-btn modal-apply">
                                                    Apply
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </div>
                        </Popover.Body>
                    </Popover>
                </Overlay>
            </div >
        );
    }
}

export default QutationFilter;




